// import ActivityLog from './ActivityLog';

export default {
  // component: ActivityLog,
  component: load(() =>
    import(/* webpackChunkName: "ActivityLog" */ "./ActivityLog")
  ),
  priority: 1,
  permissions: ["SystemHistoryMenu"],
  name: app.translate("main.ActivityLog"),
  icon: "history",
  drawer: true,
};
